interface StudentSelectorProps {
  students: { userId: string; fullName: string }[];
  activeUserId: string | null;
  onSelect: (userId: string) => void;
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 1).toLocaleUpperCase("tr-TR");
  return (parts[0][0] + parts[parts.length - 1][0]).toLocaleUpperCase("tr-TR");
}

// Öğretmen panelinde birden fazla öğrenci varsa, aktif öğrenciyi seçmeyi sağlar.
export default function StudentSelector({
  students,
  activeUserId,
  onSelect,
}: StudentSelectorProps) {
  if (students.length <= 1) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">Öğrenci:</span>
      {students.map((s) => {
        const active = s.userId === activeUserId;
        return (
          <button
            key={s.userId}
            type="button"
            onClick={() => onSelect(s.userId)}
            className={`inline-flex items-center gap-2 h-9 pl-2 pr-3 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
              active
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-foreground-700 border border-background-200 hover:bg-background-100"
            }`}
          >
            <span
              className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-semibold shrink-0 ${
                active ? "bg-background-50/20 text-background-50" : "bg-background-100 text-foreground-600"
              }`}
            >
              {initialsOf(s.fullName)}
            </span>
            {s.fullName}
          </button>
        );
      })}
    </div>
  );
}